import { Box, type BoxProps } from '@mantine/core';
import type { ReactNode } from 'react';
import { palette } from 'ui-lib/src/lib/color/palette';

export type ModalFooterProps = BoxProps & {
  children: ReactNode;
};

/**
 * Footer component for Mantine Modal with separator line.
 * Matches ui-lib DialogFooter styling.
 */
export const ModalFooter = ({ children, ...props }: ModalFooterProps) => (
  <Box
    style={{
      borderTop: `1px solid ${palette.neutral[10]}`,
      padding: '1rem',
    }}
    {...props}
  >
    {children}
  </Box>
);
